import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  NavBar,
  Button,
  Loading,
  PaymentForm,
  UserInformationForm,
  CardFlags,
} from "components";
import { SdkPt } from "models";
import { SearchPix } from "./Search";
import usePayment from "hooks/usePayment";
import { useWhitelabel } from "hooks/useWhitelabel";
import {
  EnumOriginPayment,
  EnumTypeDebit,
  MappedDebitsToGetInstallments,
} from "services/CreditCard";
import { useGetWhiteLabel } from "services/ParcelamosService";

import Order1 from "assets/images/icons/order-1.svg";
import Order2 from "assets/images/icons/order-2.svg";
import Order3 from "assets/images/icons/order-3.svg";
import * as S from "./styles";
import { id_establishment_default } from "config/establishment";
import PaymentSummary from "components/PaymentForm/components/ResumeSummary";
import PaymentCheckout from "components/PaymentForm/components/PaymentCheckout";
import { EnumStages } from "views/Partner/types";
import { useIsMutating } from "react-query";

export const PixView = () => {
  const { id_usuario } = useParams();
  const { client } = useWhitelabel();
  const { isLoading } = useGetWhiteLabel(
    id_usuario || (client?.id_usuario as string)
  );
  const [sdkPT, setSdkPT] = useState<SdkPt>({} as SdkPt);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [tokenRecaptcha, setTokenRecaptcha] = useState<string | null>(null)

  const { state } = useLocation();

    const activeMutatingInstallments = useIsMutating({ mutationKey: "get-installments" })

  const [stage, setStage] = useState<EnumStages>(EnumStages.SEARCH);
  const {
    paymentForm,
    dataPaymentBillet,
    setPaymentForm,
    getInstallments,
    clearPaymentBilletData,
  } = usePayment();

  const getIconStage = (stage: EnumStages) =>
    [Order1, Order2, Order3][stage - 1];

  const goBack = () => {
    setStage(stage - 1);
  };

  function handleChangeStage(nextStage: EnumStages) {
    if (nextStage === EnumStages.PAYMENT_FORM) {
      const debits: MappedDebitsToGetInstallments =
        dataPaymentBillet.pix.map(({ id_pix }) => ({
          type: EnumTypeDebit.PIX,
          id_pix,
        }));

      const request = {
        idEstablishment: client?.id_usuario || id_usuario,
        data: { origin: EnumOriginPayment.ONLINE, debits },
      };

      getInstallments(request, {
        onError(error: any) {
          toast.error(error?.response?.data?.message);
        },
      }).then(() => {
        setStage(nextStage);
      });
      return;
    }

    setStage(nextStage);
  }

  useEffect(() => {
    if (state) {
      handleChangeStage(state.stage);
    }
  }, [state]);

  useEffect(() => {
    return clearPaymentBilletData;
  }, []);


  return (
    <Loading isLoading={isLoading} size="large">
      <NavBar />
      <S.Wrapper>
        <S.Button>
          {stage === EnumStages.SEARCH || stage === EnumStages.ORDER_DETAILS ? (
            <></>
          ) : (
            <Button
              title={`Voltar para etapa`}
              type_button="outlined"
              icon_right={getIconStage(stage - 1)}
              onClick={goBack}
            />
          )}
        </S.Button>
      </S.Wrapper>

      <S.WrapperStages>
        <SearchPix
          setStage={handleChangeStage}
          enable={stage === EnumStages.SEARCH}
          hasBilletActions={client?.action_button_billet}
          idEstablishment={
            id_usuario ?? client?.id_usuario ?? id_establishment_default
          }
        />
        <UserInformationForm
          enable={stage === EnumStages.CLIENT_IDENTIFICATION}
          setStage={handleChangeStage}
          stage={stage}
        />
        <PaymentForm
          setStage={handleChangeStage}
          paymentForm={paymentForm}
          setPaymentForm={setPaymentForm}
          showSummary={false}
          enable={stage === EnumStages.PAYMENT_FORM}
          setSdkPT={setSdkPT}
        />

        {stage === EnumStages.SUMMARY && (
          <PaymentSummary
            route="parceiro"
            stage={stage}
            onBack={goBack}
            nextStage={() => handleChangeStage(EnumStages.PAYMENT_METHODS)}
            setTokenRecaptcha={setTokenRecaptcha}
            tokenRecaptcha={tokenRecaptcha}
            isLoadingInstallments={!!activeMutatingInstallments}
          />
        )}
        {stage === EnumStages.PAYMENT_METHODS && (
          <PaymentCheckout
            stage={stage}
            route="parceiro"
            tokenRecaptcha={tokenRecaptcha}
            setTokenRecaptcha={setTokenRecaptcha}
          />
        )}

        {stage !== EnumStages.ORDER_DETAILS ? <CardFlags /> : null}
      </S.WrapperStages>
    </Loading>
  );
};
